export default __webpack_public_path__ + "static/media/SemiBold.96c6887a.eot";